import React from 'react';

const DynamicComponent = ({ componentName, directory, contents }) => {
  const Component = require(`../Components/${directory}/${componentName}`).default;
  return <Component contents={contents} />;
};

export default DynamicComponent;